{
	"title": "Уведомления",
	"empty": "Уведомлений нет",
	"emptyHint": "Когда AI закончит обработку или появятся напоминания — увидите их здесь.",
	"markAllRead": "Прочитать все",
	"markRead": "Отметить прочитанным",
	"markUnread": "Отметить непрочитанным",
	"delete": "Удалить",
	"settings": "Настройки уведомлений",
	"openDetail": "Открыть",
	"unreadOnly": "Только непрочитанные",
	"unreadCount": "{count, plural, one {# непрочитанное} few {# непрочитанных} other {# непрочитанных}}",
	"loadMore": "Показать ещё",
	"loading": "Загружаем…",
	"errorTitle": "Не удалось загрузить уведомления",
	"retry": "Повторить",
	"filters": {
		"all": "Все",
		"ai": "AI",
		"billing": "Биллинг",
		"streak": "Серии",
		"system": "Система"
	},
	"groups": {
		"today": "Сегодня",
		"yesterday": "Вчера",
		"thisWeek": "На этой неделе",
		"earlier": "Ранее"
	},
	"actions": {
		"menu": "Действия с уведомлением",
		"close": "Закрыть панель"
	},
	"categories": {
		"ai_task_complete": "AI-задача",
		"study_reminder": "Напоминание",
		"system_alert": "Система",
		"access_granted": "Доступ",
		"subscription_alert": "Подписка",
		"security_alert": "Безопасность"
	},
	"aggregated": {
		"title": "{count, plural, one {# новый артефакт} few {# новых артефакта} other {# новых артефактов}}",
		"expand": "Развернуть",
		"collapse": "Свернуть"
	},
	"types": {
		"materialReady": "Материал обработан",
		"notesReady": "Конспект готов",
		"flashcardsReady": "Карточки готовы",
		"quizReady": "Тест готов",
		"essayGraded": "Эссе проверено",
		"srsReminder": "Время повторения",
		"streakAtRisk": "Стрик под угрозой",
		"examSoon": "Скоро экзамен",
		"subscriptionRenewed": "Подписка продлена",
		"subscriptionExpired": "Подписка истекла",
		"quotaWarning": "Приближается лимит тарифа"
	},
	"channels": {
		"inApp": "В приложении",
		"email": "На почту",
		"push": "Push-уведомления"
	},
	"detail": {
		"back": "К уведомлениям",
		"openArtifact": "Открыть",
		"context": "Связано с",
		"createdAt": "Создано",
		"notFound": "Уведомление не найдено или удалено."
	},
	"pushPermission": {
		"title": "Включить push-уведомления?",
		"subtitle": "Мы пришлём push, когда AI закончит обработку и пора будет повторить материал. Можно отключить в настройках.",
		"allow": "Разрешить",
		"later": "Позже",
		"enabled": "Push-уведомления включены",
		"deniedHint": "Разрешение не выдано. Включить можно в настройках браузера."
	},
	"pushUpdate": {
		"message": "Чтобы получать push-уведомления, обновите приложение StudyHub до последней версии.",
		"action": "Обновить"
	},
	"disclaimer": {
		"titles": {
			"chat": "AI-чат — пользуйтесь с пониманием",
			"generation": "AI-генерация — проверяйте источники",
			"essay": "Проверка эссе — рекомендация, не приговор",
			"visuals": "Распознавание изображений — может ошибаться",
			"notes": "AI-конспекты опираются на материал",
			"web-search": "Web-поиск — внешние источники"
		},
		"body": "AI может ошибаться или галлюцинировать. Всегда сверяйтесь с исходным материалом, особенно для важных решений.",
		"dontShowAgain": "Больше не показывать",
		"gotIt": "Понятно",
		"openTerms": "Условия и AI-дисклеймер"
	},
	"toast": {
		"marked": "Отмечено как прочитанное",
		"deleted": "Уведомление удалено",
		"undo": "Отменить",
		"allRead": "Все уведомления прочитаны",
		"open": "Открыть"
	}
}
